import useProtoMethod from "./useProtoMethod";
import {
  AdminCreateDelegationTaskRequest,
  AdminCreateDelegationTaskResponse,
  AdminListDelegationTasksRequest,
  AdminListDelegationTasksResponse,
  AdminUpdateDelegationTaskRequest,
  AdminUpdateDelegationTaskResponse,
  CreateDelegationTaskRequest,
  CreateDelegationTaskResponse,
  GetDelegationTaskRequest,
  GetDelegationTaskResponse,
  GetMemberDelegationTaskRequest,
  GetMemberDelegationTaskResponse,
  ListDelegationTasksRequest,
  ListDelegationTasksResponse,
  UpdateDelegationTaskRequest,
  UpdateDelegationTaskResponse,
  UpdateMemberDelegationTaskRequest,
  UpdateMemberDelegationTaskResponse,
  UpdateDelegationTaskCommentRequest,
  UpdateDelegationTaskCommentResponse,
  DeleteDelegationTaskCommentRequest,
  DeleteDelegationTaskCommentResponse,
  ListMemberDelegationTasksRequest,
  ListMemberDelegationTasksResponse,
  ApplyDelegationTaskDetailsUpdateRequest,
  ApplyDelegationTaskDetailsUpdateResponse,
} from "../protogen/delegation_service_pb";

export const useCreateDelegationTask = (
  callback?: (r: CreateDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    CreateDelegationTaskRequest,
    CreateDelegationTaskResponse
  >("CreateDelegationTask", CreateDelegationTaskResponse, { callback });
};

export const useAdminCreateDelegationTask = (
  callback?: (r: AdminCreateDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    AdminCreateDelegationTaskRequest,
    AdminCreateDelegationTaskResponse
  >("AdminCreateDelegationTask", AdminCreateDelegationTaskResponse, {
    callback,
  });
};

export const useAdminListDelegationTasks = (
  callback?: (r: AdminListDelegationTasksResponse) => void,
) => {
  return useProtoMethod<
    AdminListDelegationTasksRequest,
    AdminListDelegationTasksResponse
  >("AdminListDelegationTasks", AdminListDelegationTasksResponse, { callback });
};

export const useAdminUpdateDelegationTask = (
  callback?: (r: AdminUpdateDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    AdminUpdateDelegationTaskRequest,
    AdminUpdateDelegationTaskResponse
  >("AdminUpdateDelegationTask", AdminUpdateDelegationTaskResponse, {
    callback,
  });
};

export const useListDelegationTasks = (
  callback?: (r: ListDelegationTasksResponse) => void,
) => {
  return useProtoMethod<
    ListDelegationTasksRequest,
    ListDelegationTasksResponse
  >("ListDelegationTasks", ListDelegationTasksResponse, { callback });
};

export const useUpdateDelegationTask = (
  callback?: (r: UpdateDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    UpdateDelegationTaskRequest,
    UpdateDelegationTaskResponse
  >("UpdateDelegationTask", UpdateDelegationTaskResponse, { callback });
};

export const useGetDelegationTask = (
  callback?: (r: GetDelegationTaskResponse) => void,
) => {
  return useProtoMethod<GetDelegationTaskRequest, GetDelegationTaskResponse>(
    "GetDelegationTask",
    GetDelegationTaskResponse,
    { callback },
  );
};

export const useGetMemberDelegationTask = (
  callback?: (r: GetMemberDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    GetMemberDelegationTaskRequest,
    GetMemberDelegationTaskResponse
  >("GetMemberDelegationTask", GetMemberDelegationTaskResponse, { callback });
};

export const useUpdateMemberDelegationTask = (
  callback?: (r: UpdateMemberDelegationTaskResponse) => void,
) => {
  return useProtoMethod<
    UpdateMemberDelegationTaskRequest,
    UpdateMemberDelegationTaskResponse
  >("UpdateMemberDelegationTask", UpdateMemberDelegationTaskResponse, {
    callback,
  });
};

export const useUpdateDelegationTaskComment = (
  callback?: (r: UpdateDelegationTaskCommentResponse) => void,
) => {
  return useProtoMethod<
    UpdateDelegationTaskCommentRequest,
    UpdateDelegationTaskCommentResponse
  >("UpdateDelegationTaskComment", UpdateDelegationTaskCommentResponse, {
    callback,
  });
};

export const useDeleteDelegationTaskComment = (
  callback?: (r: DeleteDelegationTaskCommentResponse) => void,
) => {
  return useProtoMethod<
    DeleteDelegationTaskCommentRequest,
    DeleteDelegationTaskCommentResponse
  >("DeleteDelegationTaskComment", DeleteDelegationTaskCommentResponse, {
    callback,
  });
};

export const useListMemberDelegationTasks = (
  callback?: (r: ListMemberDelegationTasksResponse) => void,
) => {
  return useProtoMethod<
    ListMemberDelegationTasksRequest,
    ListMemberDelegationTasksResponse
  >("ListMemberDelegationTasks", ListMemberDelegationTasksResponse, {
    callback,
  });
};

export const useApplyDelegationTaskDetailsUpdate = (
  callback?: (r: ApplyDelegationTaskDetailsUpdateResponse) => void,
) => {
  return useProtoMethod<
    ApplyDelegationTaskDetailsUpdateRequest,
    ApplyDelegationTaskDetailsUpdateResponse
  >(
    "ApplyDelegationTaskDetailsUpdate",
    ApplyDelegationTaskDetailsUpdateResponse,
    { callback },
  );
};
